import { gql } from 'apollo-angular';
import { workspaceUserItemFragment } from './user.fragments';

export const UserDetailQuery = gql`
  query WorkspaceUserDetailQuery($id: ID!) {
    node(id: $id) {
      ... on User {
        ...WorkspaceUserItem

        workspaceDashboardRoles {
          edges {
            node {
              ... on DashboardRole {
                id
                dashboardRoleAccessLevel: accessLevel
                title

                dashboard {
                  id
                  title
                }
              }

              ... on WorkspaceRole {
                id
                workspaceRoleAccessLevel: accessLevel
                title
                workspace {
                  id
                  title
                  alternativeTitle

                  dashboard {
                    id
                    title

                    dashboardFormat {
                      id
                      shortName
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${workspaceUserItemFragment}
`;

export const UserByEmailQuery = gql`
  query WorkspaceUserByEmailQuery($email: String!) {
    userByEmail(email: $email) {
      ...WorkspaceUserItem

      workspaceDashboardRoles {
        edges {
          node {
            ... on DashboardRole {
              id
              dashboardRoleAccessLevel: accessLevel
              title

              dashboard {
                id
              }
            }

            ... on WorkspaceRole {
              id
              workspaceRoleAccessLevel: accessLevel
              title

              workspace {
                id
              }
            }
          }
        }
      }
    }
  }
  ${workspaceUserItemFragment}
`;

export const UserAvatarQuery = gql`
  query WorkspaceUserAvatarQuery($id: ID!) {
    node(id: $id) {
      ... on User {
        id
        avatarUrl
        thumbUrl
      }
    }
  }
`;
